import { Observable, Subject } from 'rxjs';

const _groupSizesChange$ = new Subject<void>();
const groupSizesChange$ = _groupSizesChange$.asObservable();

export function getGroupSizesChange$(): Observable<void> {
  return groupSizesChange$;
}

export function notifyGroupSizesChange(): void {
  _groupSizesChange$.next();
}
